import { USER_TYPES } from '../../services/user';
import { QuestionnaireTypes } from '../../services/questionnaires';

// MPA BP writes are VENDOR_ADMIN-only; the empty-set repair path is intentionally ungated (TPE-2942).
export function isMpaBestPracticeWriteGated(
  userType: string | undefined,
  questionnaireType: string | undefined,
): boolean {
  return userType !== USER_TYPES.VENDOR_ADMIN && questionnaireType === QuestionnaireTypes.MPA_BEST_PRACTICE;
}
